import { useState, type FocusEvent, type MouseEvent } from 'react'
import { createPortal } from 'react-dom'

/**
 * Индикатор состояния нейронки: тонкая полоска-подчёркивание под логотипом
 * модели (вариант «8», выбор владельца 2026-08-13 после примерки макетов:
 * сплошная, закруглённые концы, мягкое свечение, без растушёвки). Красная
 * (сбой) мягко пульсирует, зовя навести курсор.
 *
 * Тултип на ховер/фокус — порталом в body: внутри строк селекта absolute-
 * тултипы режутся overflow'ом (тот же урок, что у щитов ограничений,
 * см. RestrictionShields). У красного в тултипе — предупреждение, что модель
 * может быть недоступна.
 *
 * Рендерить внутри позиционированного якоря вокруг .model-icon (сама иконка
 * режет выходящее за края своим overflow: hidden).
 */
export default function HealthDot({ status, color, label }: { status: string; color: string; label: string }) {
	const [tip, setTip] = useState<{ x: number; y: number } | null>(null)

	const show = (e: MouseEvent<HTMLElement> | FocusEvent<HTMLElement>) => {
		const r = e.currentTarget.getBoundingClientRect()
		setTip({ x: r.left + r.width / 2, y: r.top - 8 })
	}
	const hide = () => setTip(null)

	return (
		<span
			className={`health-bar${status === 'down' ? ' health-bar--down' : ''}`}
			// Свечение — тот же цвет со сниженной альфой (hex из HEALTH_UI 6-значный)
			style={{ '--bar-color': color, '--bar-glow': `${color}66` } as React.CSSProperties}
			tabIndex={0}
			aria-label={label}
			onMouseEnter={show}
			onMouseLeave={hide}
			onFocus={show}
			onBlur={hide}
		>
			{tip &&
				createPortal(
					<span className="rshield__tip" role="tooltip" style={{ left: tip.x, top: tip.y }}>
						<b className="rshield__tip-title">{label}</b>
						{status === 'down' && (
							<span className="rshield__tip-text">
								Может быть недоступна — попробуйте позже или выберите другую модель.
							</span>
						)}
					</span>,
					document.body,
				)}
		</span>
	)
}
